export class LiquiditySource {
  public identifier: string;
  public readableName: string;
  public iconUrl: string;
  public subLiquiditySources: LiquiditySource[];
  public native: boolean;

  // View setting: User can enable/disable sources
  public enabled: boolean;

  public getSubSourceCount(): number {
    return this.subLiquiditySources.length;
  }

  public getEnabledSubSourceCount(): number {
    return this.subLiquiditySources.filter(source => source.enabled).length;
  }

  /**
   * Checks if enabled states of source and sub sources are equal.
   *
   * @param other
   */
  public equals(other: LiquiditySource): boolean {
    if (this.enabled !== other.enabled) {
      return false;
    }

    for (const thisSubSource of this.subLiquiditySources) {
      const otherSubSource = other.subLiquiditySources.find(
        subSource => subSource.identifier === thisSubSource.identifier,
      );
      if (!otherSubSource || thisSubSource.enabled !== otherSubSource.enabled) {
        return false;
      }
    }

    return true;
  }
}
